import { ChangeEvent, useState } from 'react';
import SearchIcon from '../Icons/SearchIcon';
import FilterSidebar from './FilterSidebar';
import FilterIcon from '../Icons/FilterIcon';
import { IFilterSideBarForm, IOrderByList } from '@/interfaces/common.model';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import {
  IAttendanceHandle,
  IAttendanceSortList,
  IAttendanceStatus,
} from '@/interfaces/attendance.model';
import { IWfhSortList } from '@/pages/HRM/WFH/TeamWfh';
import { IEmployeeList } from '@/interfaces/employee.model';
import {
  ILeavePageStates,
  IRemainingLeaveItem,
} from '@/pages/HRM/Leave/MyLeave';
import { ITeamLeaveSort } from '@/interfaces/leave.model';
import SearchSelectBox, { ISelectOption } from '../ui/SearchSelectBox';
import { SingleValue } from 'react-select';
import { ICompany } from '@/interfaces/company.model';
import { useDispatch } from 'react-redux';
import { setTableView } from '@/redux/features/UserSlice';
import { IAssetSortList } from './FilterSidebar';

export interface IFilterArray<T> {
  isShow?: boolean;
  sortList?: T;
}
interface IFilterComponentProps<T> {
  exportFileName?: string;
  exportColumns?: string[];
  searchBar?: boolean;
  handleSearch?: (e: ChangeEvent<HTMLInputElement>) => void;
  searchPlaceHolder?: string;
  filterArray?: IFilterArray<T>;
  orderByHandler?: (e: ChangeEvent<HTMLSelectElement>) => void;
  employeeList?: IEmployeeList;
  orderByList?: IOrderByList[];
  isGrid?: boolean;
  attendanceList?: IAttendanceStatus[] | null;
  handleFilterForAttendance?: (data: IAttendanceHandle) => void;
  handleExport?: (() => void) | null;
  attendanceSortList?: IAttendanceSortList;
  sortHandler?: (
    data: Partial<IFilterSideBarForm> | null,
    type?: null | string,
  ) => void;
  wfhStatus?: IWfhSortList;
  leaveList?: IRemainingLeaveItem[];
  handleFilterForLeave?: React.Dispatch<React.SetStateAction<ILeavePageStates>>;
  TeamLeaveSort?: ITeamLeaveSort;
  companyList?: ICompany[];
  handleSearchChange?: (
    option: SingleValue<ISelectOption>,
    type: string,
  ) => void;

  getCompanyList?: (inputValue: string) => Promise<ISelectOption[]>;
  userStatus?: boolean;
  assetSortList?: IAssetSortList;
  reminderClick?: (() => void) | null;
  reminderLoading?: boolean;
}
const FilterComponent = <T,>({
  orderByHandler,
  orderByList,
  handleSearch,
  searchPlaceHolder,
  filterArray,
  isGrid = true,
  employeeList,
  attendanceList,
  attendanceSortList,
  handleExport,
  sortHandler,
  wfhStatus,
  leaveList,
  handleFilterForLeave,
  TeamLeaveSort,
  companyList,
  getCompanyList,
  handleSearchChange,
  userStatus,
  assetSortList,
  reminderClick,
  reminderLoading,
}: IFilterComponentProps<T>) => {
  const [isShow, setIsShow] = useState<boolean>(false);
  // const tableViewButtons = [
  //   { value: 'grid', icon: <i className="bi bi-grid-fill fs-5"></i> },
  //   { value: 'table', icon: <i className="bi bi-list-task fs-5"></i> },
  // ];
  const filterDetails = useSelector(
    (state: RootState) => state.user.filtersStates,
  );
  const dispatch = useDispatch();
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const toggle = () => {
    setIsShow(!isShow);
  };
  return (
    <>
      <div
        className={`table-head d-flex align-items-center ${
          handleSearch ? 'justify-content-between' : 'justify-content-end'
        } mb-4 border-bottom pb-3 flex-wrap row-gap-3`}
      >
        {handleSearch && (
          <div className="position-relative">
            <span className="search-icon">
              <SearchIcon />
            </span>
            <input
              type="text"
              className="form-control search-control"
              id="searchUsers"
              placeholder={searchPlaceHolder ? searchPlaceHolder : 'Search'}
              onChange={handleSearch}
            />
          </div>
        )}
        {/* {officeStates && (
          <div className="d-flex gap-3 align-items-center flex-wrap">
            <div className="select-wrapper">
              <select
                className="form-select"
                value={officeStates?.selectedOfficeId || ''}
                onChange={(e) => {
                  const selected = officeStates?.officeList?.find(
                    (s) => String(s?.id) === e.target.value,
                  );
                  setofficeStates((prev) => ({
                    ...prev,
                    selectedOfficeId: selected ? selected.id : '',
                  }));
                }}
              >
                {officeStates?.officeList?.length > 0 ? (
                  <>
                    <option value="" disabled>
                      Select office
                    </option>
                    {officeStates?.officeList?.map((s) => (
                      <option key={s?.id} value={s?.id}>
                        {s?.name}
                      </option>
                    ))}
                  </>
                ) : (
                  <option disabled>No office found</option>
                )}
              </select>
            </div>
          </div>
        )} */}
        <div className="d-flex gap-3">
          {orderByHandler && (
            <div className="d-flex align-items-center gap-3 px-2">
              <select
                className="form-select pe-5"
                style={{ cursor: 'pointer' }}
                onChange={orderByHandler}
                value={filterDetails?.orderBy ?? ''}
              >
                {orderByList &&
                  orderByList?.length > 0 &&
                  orderByList?.map((item, index) => (
                    <option key={index} value={item?.value}>
                      {item?.name}
                    </option>
                  ))}
              </select>
            </div>
          )}
          {companyList && (
            <div className="d-flex gap-3">
              <div className="position-relative">
                <SearchSelectBox
                  value={filterDetails?.companyId}
                  onChange={(option) =>
                    handleSearchChange &&
                    handleSearchChange(option, 'companyId')
                  }
                  fetchOptions={getCompanyList}
                  // loading={state?.companyIsLoading}
                  isAsync={true}
                  defaultFetch={true}
                  title={'Search Company'}
                  isUsingFilter={true}
                />
              </div>
            </div>
          )}
          {reminderClick && (
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={reminderClick}
              disabled={reminderLoading}
            >
              {reminderLoading ? 'Sending...' : 'Reminder'}
            </button>
          )}
          {handleExport && (
            <button
              type="button"
              className="btn btn-outline-primary "
              onClick={handleExport}
            >
              Export
            </button>
          )}

          {filterArray && filterArray?.isShow && (
            <div className="d-flex  justify-content-end gap-3">
              <button
                className="btn btn-outline-primary filter-btn py-3"
                onClick={() => toggle()}
              >
                <FilterIcon />
              </button>
            </div>
          )}

          {isGrid && (
            <div className="d-flex justify-content-end">
              <div className="btn-group btn-group-toggle" role="group">
                <input
                  onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                    if (!e?.currentTarget?.value) {
                      return;
                    }
                    dispatch(
                      setTableView(e?.currentTarget?.value as 'table' | 'grid'),
                    );
                  }}
                  id={tableView == 'grid' ? 'table' : 'grid'}
                  type="radio"
                  name="view-type"
                  value={tableView == 'grid' ? 'table' : 'grid'}
                  className="btn-check"
                  autoComplete="off"
                />
                <label
                  htmlFor={tableView == 'grid' ? 'table' : 'grid'}
                  className={`btn btn-outline-primary `}
                >
                  {tableView == 'grid' ? (
                    <i className="bi bi-list-ul fs-4"></i>
                  ) : (
                    <i className="bi bi-grid-fill fs-5"></i>
                  )}
                </label>
                {/* {tableViewButtons?.map((view) => {
                return (
                  <>
                    <input
                      onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                        if (!e?.currentTarget?.value) {
                          return;
                        }
                        dispatch(
                          setTableView(
                            e?.currentTarget?.value as 'table' | 'grid',
                          ),
                        );
                      }}
                      id={view?.value}
                      type="radio"
                      name="view-type"
                      value={view?.value}
                      className="btn-check"
                      autoComplete="off"
                    />
                    <label
                      htmlFor={view?.value}
                      className={`btn btn-outline-primary ${tableView === view.value ? 'active' : ''}`}
                    >
                      {view?.icon}
                    </label>
                  </>
                );
              })} */}
              </div>
            </div>
          )}
        </div>
        {filterArray && (
          <FilterSidebar<IFilterArray<T>>
            userStatus={userStatus}
            isOpen={isShow}
            employeeList={employeeList}
            toggle={toggle}
            sortList={filterArray}
            attendanceList={attendanceList}
            sortHandler={sortHandler}
            attendanceSortList={attendanceSortList}
            wfhStatus={wfhStatus}
            leaveList={leaveList}
            handleFilterForLeave={handleFilterForLeave}
            TeamLeaveSort={TeamLeaveSort}
            assetSortList={assetSortList}
          />
        )}
      </div>
    </>
  );
};
export default FilterComponent;
